@if (options()) {
  <div class="d-flex flex-row pb-4">
    <h2>{{ translations.title }}</h2>
  </div>
  <div
    class="d-flex flex-lg-row flex-md-column flex-sm-column justify-content-between flex-wrap p-2 pb-2"
  >
    <div class="pb-2">
      @if (options().searchComponent) {
        <ng-container
          [ngComponentOutlet]="options().searchComponent || null"
          [ngComponentOutletInputs]="{
            data: {
              setPaginationState: setPaginationState,
              setStateParams: setStateParams,
            },
          }"
          #search="ngComponentOutlet"
        />
      } @else if (options().extraLeftComponent) {
          <ng-container
            [ngComponentOutlet]="options().extraLeftComponent || null"
            [ngComponentOutletInputs]="{
              data: {
                tblOptions: options,
                defaultSearch: requestForData,
                resetPageNumber: resetPageNumber,
                extra: extra,
                tbl: tblInstance
              },
            }"
            #extraLeft="ngComponentOutlet"
          />
      }
    </div>

    <div class="pb-2 justify-content-end">
      @if (options().extraLeftComponent && options().searchComponent) {
        <ng-container
          [ngComponentOutlet]="options().extraLeftComponent || null"
          [ngComponentOutletInputs]="{
            data: {
              tblOptions: options,
              defaultSearch: requestForData,
              resetPageNumber: resetPageNumber,
              extra: extra,
              tbl: tblInstance
            },
          }"
          #extraLeft="ngComponentOutlet"
        />
      }

        <ng-container
          [ngComponentOutlet]="options().extraComponent || null"
          [ngComponentOutletInputs]="{
            data: {
              tblOptions: options,
              defaultSearch: requestForData,
              resetPageNumber: resetPageNumber,
              tbl: tblInstance
            },
          }"
          #extra="ngComponentOutlet"
        />

    </div>
  </div>
  <table
    [id]="options().id"
    [class]="'table table-striped' + (options().tableClass || '')"
  >
    <thead>
      <tr>
        @for (item of Object.keys(translations.headers); track $index; let i = $index) {
          @if (!options().ignoreColumns || (options().ignoreColumns && !options().ignoreColumns!.includes(item))) {
            <th
              scope="col"
              [class]="item"
              type="heading"
              [sortable]="item"
              (sort)="onSort($event)"
            >
              {{ translations.headers[item] }}
            </th>
          }
        }
        @if (options().actionsComponent) {
          <th
            class="actionsHeading"
            scope="col"
            type="heading"
          >
            {{ defaultTranslations.actions }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of data(); track $index; let ri = $index) {
        <tr
          (click)="options().onRowClick?.(row)"
          [class.clickable]="options().onRowClick"
        >
          @for (item of Object.keys(translations.headers); track $index; let i = $index) {
            @if (!options().ignoreColumns || (options().ignoreColumns && !options().ignoreColumns!.includes(item))) {
              @if (item === 'no') {
                <td>{{ itemsPerPage * (pageNumber - 1) + (ri + 1) }}</td>
              } @else {
                <td #td>{{ options().renderCustomRow?.(td, data()[ri], item) || data()[ri][item] }}</td>
              }
            }
          }
          @if (options().actionsComponent) {
            <td>
              <ng-container
                [ngComponentOutlet]="options().actionsComponent || null"
                [ngComponentOutletInputs]="{
                  data: row,
                  allData: data(),
                  reloadData: requestForData,
                  index: ri,
                  tbl: tblInstance
                }"
                #outlet="ngComponentOutlet"
              />
            </td>
          }
        </tr>
      }
    </tbody>
  </table>

  <div
    class="d-flex flex-lg-row flex-md-column flex-sm-column justify-content-between flex-wrap p-2"
  >
    <div class="pb-2">
      @if (pagination().totalItems > 0) {
        <ngb-pagination
          [directionLinks]="true"
          [boundaryLinks]="true"
          [collectionSize]="pagination().totalItems"
          [(page)]="pageNumber"
          [pageSize]="itemsPerPage"
        >
          <ng-template
            ngbPaginationPages
            let-page
            let-pages="pages"
          >
            @if (pages.length > 0) {
              <li class="ngb-custom-pages-item">
                <div class="d-flex flex-nowrap px-2">
                  <ncp-input
                    class="d-flex flex-nowrap"
                    [options]="{
                      id: 'paginationInput',
                      type: InputTypes.text,
                      mode: InputModes.numeric,
                      pattern: FILTER_ONLY_NUMBERS,
                      label: {
                        id: 'paginationInputLabel',
                        class: 'col-form-label mx-2',
                        text: 'page',
                      },
                      placeholder: 'dots',
                      value: page,
                      onKeyUp: onPaginationInputKeyUp,
                      onBlur: onPaginationInputBlur,
                      onInput: onPaginationInput,
                      maxSize: pages.length.toString().length,
                    }"
                  />
                  <span
                    id="paginationDescription"
                    class="col-form-label text-nowrap mx-2"
                  >
                    {{ defaultTranslations.of }} {{ pages.length }}</span
                  >
                </div>
              </li>
            }
          </ng-template>
        </ngb-pagination>
      }
    </div>
    <div class="pb-2">
      @if (pagination().totalItems > 0) {
        <ncp-select [(options)]="ippSelOptions" />
      }
    </div>
  </div>
} @else {
  <div
    class="alert alert-danger"
    role="alert"
  >
    <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot instantiate table without
    options set
  </div>
}
